const KEY_PREFIX = 'requestFilters.';

export function loadUserState(method) {
    try {
        const raw = localStorage.getItem(KEY_PREFIX + method);
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
}

export function saveUserState(method, userState) {
    try {
        localStorage.setItem(KEY_PREFIX + method, JSON.stringify(userState));
    } catch (e) {
        // квота/приватный режим — персист не критичен
    }
}
